

































































































































































































import { Component, Vue } from 'vue-property-decorator';
import PerformoFooter from '@/components/system/Footer.vue';
import MainMenu from '@/components/system/MainMenu.vue';
import InOutChanger from '@/components/system/InOutChanger.vue';

import AuthService from '@/services/AuthService';
import { SystemApi, User as PerformoUser } from 'performo-api';
import { User } from 'oidc-client';
import { mapGetters } from 'vuex';
import { GlobalErrorDisplay } from './models/GlobalErrorDisplay';

const auth = new AuthService();

@Component({
  components: {
    PerformoFooter,
    MainMenu,
    InOutChanger
  },
  computed: mapGetters({
    performoUser: 'performoUser',
    currentPropertyId: 'currentPropertyId',
    currentError: 'currentError'
  })
})
export default class App extends Vue {
  private refreshing = false;
  private registration = {};
  private updateExists = false;

  private drawer = false;
  private loading = true;

  private currentError!: GlobalErrorDisplay;

  get systemName(): string {
    return this.$store.state.systemName;
  }
  get appTitle(): string {
    return this.$store.state.appTitle;
  }

  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }

  get globalStateLoaded() {
    return this.$store.getters.globalStateLoaded;
  }

  get isNotSupportedBrowser() {
    return (
      navigator.appName == 'Microsoft Internet Explorer' ||
      !!(
        navigator.userAgent.match(/Trident/) ||
        navigator.userAgent.match(/rv:11/)
      )
    );
  }

  private async mounted() {
    auth.getUser().then((user) => {
      if (user) {
        if (user.expired) {
          auth.login();
        }
        // commit to the store
        this.$store.commit('setUser', user);
        // const api = new UsersApi(this.$store.getters.getApiConfiguration);
        const settingsApi = new SystemApi(
          this.$store.getters.getApiConfiguration
        );
        settingsApi.getSettings().then((s) => {
          this.$store.commit('setSettings', s); // commit the settings to the store
          if (this.userHasInterface(user, 'FM Access')) {
            this.$store.commit('setAppTitle', 'Performo™ System');
          } else if (this.userHasInterface(user, 'Worker')) {
            this.$store.commit('setAppTitle', 'Performo™ Worker System');
          } else {
            this.$store.commit('setAppTitle', 'Performo™ Request System');
          }
          this.$store.commit('setSystemName', s.systemLogoText);
        });

        this.$store.getters.usersApi
          .getMyProfile()
          .then((pmoUser: PerformoUser) =>
            this.$store.commit('setPerformoUser', pmoUser)
          );
      } else {
        auth.login();
      }
    });

    // Accessibility alt text for svg image in main navigation
    const svgNav = document.querySelector('.svg-inline--fa.fa-bars');
    if (svgNav != null) {
      svgNav.setAttribute('alt', 'Main Navigation');
    }
  }

  private logout(): Promise<void> {
    return auth.logout();
  }

  private userHasInterface(user: User, iface: string): boolean {
    if (!user.profile) {
      return false;
    } // bail out if we can't read the profile object
    if (Array.isArray(user.profile.interface)) {
      return user.profile.interface.includes(iface);
    }
    return user.profile.interface === iface;
  }
}
